<div nxLayout="grid maxwidth">

    <div nxRow>
        <div nxCol="12" class="docs-grid-colored-col">
            <a [routerLink]="['/moje-hlasenia']">
                <button nxPlainButton type="button" class="back-to-claims">
                    {{'claim.new.backText' | translate}}<nx-icon name="launch" class="nx-margin-left-2xs"></nx-icon>
                </button>
            </a>
        </div>
    </div>

    <div nxRow>
        <div nxCol="12" class="docs-grid-colored-col">
            <div class="new-claim">
                <h3 nxHeadline="subsection-medium" translate class="title">claim.new.heading</h3>
                <div nxRow>
                    <ng-template ngFor let-policy="$implicit" [ngForOf]="activePolicies">
                        <div nxCol="12, 12, 12, 12, 6" class="policy-column">
                            <app-claim-policy-card [policy]="policy" [state]="policyStates.active" ></app-claim-policy-card>
                        </div>
                    </ng-template>
                    <ng-template ngFor let-policy="$implicit" [ngForOf]="inactivePolicies">
                        <div nxCol="12, 12, 12, 12, 6" class="policy-column">
                            <app-claim-policy-card [policy]="policy" [state]="policyStates.past" ></app-claim-policy-card>
                        </div>
                    </ng-template>
                </div>
            </div>
        </div>
    </div>
</div>
